require('../utils/lp_boclips_video_handler');

const { $, LP } = window;
const { LpBoclipsVideoHandler } = LP.module('LpBoclips');

const LpBoclipsVideosManager = {
  isBoclips(url) {
    return String(url).toLowerCase().indexOf('boclips') >= 0;
  },

  isloggedIn() {
    return LP.config.logged_in;
  },

  showThumbnailForVisitors(data) {
    if (data) {
      if (typeof data.accessible === 'undefined' || data.accessible === null) {
        return !this.isloggedIn();
      }
      return data.accessible === false;
    }

    return !this.isloggedIn();
  },

  stopVideoIfPlaying($slide) {
    if (!this.isloggedIn()) {
      return;
    }
    const boclipsContainer = $slide.find('.boclips-video-container');
    const videoId = boclipsContainer.data('video-id');
    const player = LpBoclipsVideoHandler.getHandler(videoId, $slide.data('i'));
    if (boclipsContainer.length && player != null) {
      return player.pause();
    }
  },

  updateButton($slideElement, url, data) {
    return $slideElement.find('.btn.rrp-collection-item-action').remove();
  },

  reloadVideo($slideElement, url, data) {
    if (!this.isloggedIn()) {
      return;
    }
    const container = $slideElement.find('.boclips-video-container #boclips-player');
    if (LP.config.boclips && LP.config.boclips.player_enabled && container.length > 0) {
      const handler = new LpBoclipsVideoHandler({
        videoUrl: data.originalUrl || url,
        data
      });
      handler.init($slideElement.find('.boclips-video-container #boclips-player'));
      $slideElement.fitVids({ customSelector: '.boclips-video-container' });
    }
  },

  getVideoId($slideElement, url, data) {
    if (!this.isloggedIn()) {
      return null;
    }
    const boclipsContainer = $slideElement.find('.boclips-video-container');
    if (boclipsContainer.length > 0) {
      return boclipsContainer.data('video-id');
    }
    return null;
  },

  showBoclipsVideo($slideElement, url, data) {
    const config = LP.config.boclips;
    const handler = new LpBoclipsVideoHandler({
      videoUrl: data.originalUrl || url,
      data
    });
    if (this.showThumbnailForVisitors(data)) {
      $slideElement.html(`
        <div class='boclips-video-container' id='boclips-video-container-${handler.videoId}' data-video-id='${handler.videoId}'>
          <div id='boclips-player-wrapper'>
            <div id='lp-boclips-visitor-thumbnail' class="relative container mx-auto">
            <a class="block"
               data-html="true"
               data-placement="bottom"
               data-trigger="focus"
               data-content="<div class=&quot;text-center&nbsp;py-2&quot;><a class=&quot;bold&quot; href=&quot;/auth/users/sign_in&quot;>Sign in</a> or <a data-remote=&quot;true&quot; class=&quot;bold text-danger&quot; href=&quot;/subscription/new&quot;>Join Now</a></div>"
               data-title="Get Full Access"
               data-container="body"
               rel="popover"
               tabindex="0"
               href="/subscription/new"
               data-original-title=""
               title="">
              <img class='img-responsive lp-boclips-thumbnail z-10 w-full h-full'
                src='${data.thumbnailUrl}'
                alt='${data.title}'
                onerror='handleImageNotLoadedError(this)'
                data-default-image='/images/attachment_defaults/s3_upload/no_image.png'
              />
              <span aria-hidden="true" class="flex justify-center items-center bg-white rounded-full w-16 h-16 absolute top-1/2 left-1/2 -mt-8 -ml-8 cursor-pointer z-0 border-2 border-primary drop-shadow-md lp-boclips-thumbnail-playBtn">
                <i class="fa-solid fa-play text-primary text-3xl ml-1 drop-shadow-xl"></i>
              </span>
              </a>
            </div>
          </div>
        </div>
      `);
      $slideElement.fitVids({ customSelector: '.boclips-video-container' });
      $('[data-toggle="popover"]').popover();
      LP.module('Popovers').init();
    } else if (!config) {
      return $slideElement.html(`
        <div class="text-center">
          <h2 style="margin-top:18%;">You do not have access to this resource.</h2>
          <h3>If this is unexpected, please contact your administrator about enabling access.</h3>
        </div>
      `);
    } else if (config.player_enabled) {
      $slideElement.html(`
        <div class='boclips-video-container' id='boclips-video-container-${handler.videoId}' data-video-id='${handler.videoId}'>
          <div id='boclips-player-wrapper'>
            <div id='boclips-player'></div>
          </div>
          <div id='video-clipping-tool'></div>
         </div>
      `);
      handler.init($slideElement.find('.boclips-video-container #boclips-player'));
      $slideElement.fitVids({ customSelector: '.boclips-video-container' });
    } else {
      // Remove the spinner if the video is opened in Edit Folder modal
      if ($slideElement.hasClass('inline-contents')) $slideElement.html('');
      $slideElement.append(`
        <div id='player_unavailable_wrapper' class='row'>
          <div class='col-xs-12'>
            <div id='player-unavailable-message'>
              <h4 id='player-unavailable-title'>${LP.config.boclips.player_unavailable_title}</h4>
              <span id='player-unavailable-text'>${LP.config.boclips.player_unavailable_message}</span>
            </div>
          </div>
        </div>
      `);
    }
    return LP.module('SharedPlayer').VideoItemsManager.resizeSlide($slideElement);
  }
};

if (LP && LP.module('LpBoclips')) {
  LP.module('LpBoclips').LpBoclipsVideosManager = LpBoclipsVideosManager;
}
